// Quote-aware CSV helpers shared by the Customer Specs pages (Form, Manage, Index).
// `parseCsvList` tolerates commas inside double-quoted values (`""` is an escaped quote);
// `toCsv` quotes any value containing a comma/quote/newline or edge whitespace. Extracted
// from three byte-identical page-local copies (fix-it plan M4 / review finding U1) so a
// future change to the quoting rules is made once.

export function parseCsvList(input) {
  const s = String(input || '');
  if (!s) return [];
  const out = [];
  let curr = '';
  let inQuotes = false;
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (inQuotes) {
      if (ch === '"') {
        if (i + 1 < s.length && s[i + 1] === '"') { curr += '"'; i++; }
        else { inQuotes = false; }
      } else {
        curr += ch;
      }
    } else {
      if (ch === ',') {
        const val = curr.trim(); if (val) out.push(val); curr = '';
      } else if (ch === '"') {
        inQuotes = true;
      } else {
        curr += ch;
      }
    }
  }
  const last = curr.trim(); if (last) out.push(last);
  return out;
}

export function toCsv(values) {
  const arr = Array.isArray(values) ? values : [];
  return arr.map(v => {
    const s = String(v ?? '').trim();
    if (s === '') return '';
    const needsQuotes = /[",\n]/.test(s) || /^\s|\s$/.test(s);
    const escaped = s.replace(/"/g, '""');
    return needsQuotes ? `"${escaped}"` : escaped;
  }).filter(Boolean).join(',');
}
